import { get, post, path_version, ENCRYPT_TYPES } from '@/httpRequest/http'
import { loginEncrypt } from '@/utils/crypto'
import { getBaseUrl } from '@/utils'
import { isHLApp } from '@/utils'

const { VUE_APP_UC = '' } = process.env
const baseUrl = getBaseUrl(VUE_APP_UC)

export const getInviteeInfoOverview = ({ nickName, hlId, phone }) => {
    return get(`${baseUrl}/uc/v1/inviteeInfoOverview`, { nickName, hlId, phone }).then(res => {
        return res
    })
}

export const getInviteeInfoList = ({ invitee, start, count, sort }) => {
    const params = {}
    if (invitee !== undefined) params.invitee = invitee
    if (start !== undefined) params.start = start
    if (count !== undefined) params.count = count
    if (sort !== undefined) params.sort = sort

    return get(`${baseUrl}/uc/v1/inviteeInfoList`, {params}).then(res => {
        return res
    })
}

// 行情权限
export const GetOpenAPIPermission = params => {
    return get(`${baseUrl}/uc/v1/OpenApiPermission`, { params })
}

export const getUserDetail = () => {
    return get(`${baseUrl}/uc/v1/UserDetail`).then(res => {
        // 直接调用userDetail也需要保存一些用户数据
        try {
            const userInfo = res?.data?.result
            if (userInfo) {
                const hlId = userInfo.hlId ?? ''
                sessionStorage.setItem('hlId', hlId)
            } else {
                sessionStorage.setItem('hlId', '')
            }
        } catch (err) {
            console.log('set hlId err:', err)
        }

        return res
    })
}

export const esopTokenLogin = data => {
    return post(`${baseUrl}/uc/esop/v1/TokenLogin`, {
        data,
        // 临时会话加密
        encrypt: ENCRYPT_TYPES.EDCH,
        jsBridge: false,
    })
}

export const getEsopUserDetail = () => {
    return get(`${baseUrl}/uc/esop/v1/UserDetail`)
}

export const getUserDetailWt = subAccountId => {
    return get(`${baseUrl}/uc/${path_version}/SubAcctInfo?subAccountId=${subAccountId}`)
}
export const getClientInfo = () => {
    return get(`${baseUrl}/uc/v1/ClientInfo`)
}
/** 根据subAccountId查询用户详情 - 供同花顺使用 */
export const getSubAcctDetail = subAccountId => {
    return get(`${baseUrl}/uc/v0/SubAcctDetail?subAccountId=${subAccountId}`)
}

// 旧版发送验证码接口待废弃
export const CodeSend = data => {
    return post(`${baseUrl}/uc/v1/CodeSend`, {
        data,
        encrypt: 0,
        noEncTag: true,
    })
}

// 新版临时加密发送验证码
export const WebCodeSend = data => {
    if (isHLApp()) {
        return post(`${baseUrl}/uc/v1/AppCodeSend`, {
            data,
            encrypt: 1,
            encTag: 'tempsession/enc',
        })
    }
    return post(`${baseUrl}/uc/v1/WebCodeSend`, {
        data,
        encrypt: ENCRYPT_TYPES.EDCH, // 获取验证码 临时会话加密
        noEncTag: true,
    })
}

export const CodeVerify = data => {
    const { value, code, salt } = data
    const { A1 } = loginEncrypt(value, code, salt)

    return post(`${baseUrl}/uc/v1/CodeVerify`, {
        data: {
            salt,
            ticket: A1,
        },
        encrypt: 0,
        noEncTag: true,
    })
}

export const CodeLogin = data => {
    const { value, code, salt, aeCode, channel } = data
    const { A1, rndkey } = loginEncrypt(value, code, salt)

    return new Promise((resolve, reject) => {
        post(`${baseUrl}/uc/v1/LoginCode`, {
            data: {
                salt,
                id: value,
                ticket: A1,
                aeCode: aeCode,
                channel: channel,
            },
            encrypt: 0,
        })
            .then(res => {
                resolve(
                    Object.assign(
                        {
                            rndkey,
                        },
                        res
                    )
                )
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const LoginSms = async data => {
    const { value, code, salt, aeCode, channel, inviteeId, activityId } = data
    const { A1, rndkey } = loginEncrypt(value, code, salt)

    try {
        const res = await post(`${baseUrl}/uc/v1/LoginSms`, {
            data: {
                salt,
                id: value,
                ticket: A1,
                aeCode: aeCode,
                channel: channel,
                inviteeId,
                activityId,
            },
            encrypt: 0,
        })

        return {
            rndkey,
            ...res,
        }
    } catch (err) {
        return Promise.reject(err)
    }
}

// 香港提示符强引导
export const HkSign = async data => {
    try {
        const res = await post(`${baseUrl}/uc/${path_version}/HkIdentifierSign`, {
            data,
        })

        return res
    } catch (err) {
        return Promise.reject(err)
    }
}
/** 查询用户风险评估状态 */
export const getUserAssessStatus = params => {
    // return get(`${VUE_APP_UC}/uc/${path_version}/AssessStatus?subAcctId=${subAccountId}&subAccountId=${subAccountId}`)
    return get(`${baseUrl}/uc/${path_version}/AssessStatus`, { params })
}

/** TODO: 旧版待废弃 查询IP归属地 */
// export const LocationGet = () => {
// 	return get(`${VUE_APP_UC}/uc/${path_version}/LocationGet`)
// }

/** 查询IP归属地 */
export const WebIPLocationGet = () => {
    return post(`${baseUrl}/uc/${path_version}/WebIPLocationGet`, {
        encrypt: ENCRYPT_TYPES.EDCH, // 获取验证码 临时会话加密
        jsBridge: false, // 强制全部走http 请求   不走 jsBridge
    })
}

/**
 * 注销用户
 */
export const UserClose = data => {
    return post(`${baseUrl}/uc/v1/UserClose`, {
        data,
        encrypt: ENCRYPT_TYPES.LOGIN,
    })
}

// 登录小鹅通直播获取sdk

export const getXiaoEToken = async data => {
    try {
        const res = await post(`${baseUrl}/uc/v1/LiveLoginXiaoeWeb`, {
            data,
            encrypt: 2,
        })

        return res
    } catch (err) {
        return Promise.reject(err)
    }
}
// 香港标识符，获取证件信息
export const GetIdentityBySubAcctId = (subAcctId = '') => {
    const url = path_version === 'v1' ? '/uc/v1/GetIdentityBySubAcctId' : '/uc/v0/GetIdentityBySubAcctId'

    return get(`${baseUrl}${url}?subAcctId=${subAcctId}&subAccountId=${subAcctId}`)
}

export const YFTransSign = data => {
    return post(`${baseUrl}/uc/v1/YFTransSign`, { data })
}
export const YFSignStatus = params => {
    return get(`${baseUrl}/uc/v1/YFSignStatus`, { params })
}

// CMHK
// 获取用户信息
export const MylinkInfoByToken = data => {
    return post(`${baseUrl}/uc/v1/MylinkInfoByToken`, {
        data,
        // 临时会话加密
        encrypt: ENCRYPT_TYPES.EDCH,
    })
}

// 通过中移动登录
export const LoginMylink = data => {
    return post(`${baseUrl}/uc/v1/LoginMylink`, {
        data,
        // 临时会话加密
        encrypt: ENCRYPT_TYPES.EDCH,
    })
}
/** 用户风险等级，投资经验，投资目标，衍生品买卖标记的查询接口 */
export const UserRiskInfo = subAcctId => {
    return get(`${baseUrl}/uc/${path_version}/UserRiskInfo?subAcctId=${subAcctId}`)
}

// 修改手机号
export const PhoneModify = data => {
    return post(`${baseUrl}/uc/v1/PhoneModify`, {
        data,
        encrypt: 2,
    })
}

// 修改邮箱
export const EmailModify = data => {
    return post(`${baseUrl}/uc/v1/EmailModify`, {
        data,
        encrypt: 2,
    })
}

// 绑定邮箱
export const EmailBind = data => {
    return post(`${baseUrl}/uc/v1/EmailBind`, {
        data,
        encrypt: 2,
    })
}

//  登录名占用检查
export const LoginNameCheck = data => {
    return post(`${baseUrl}/uc/v1/LoginNameCheck`, {
        data,
        encrypt: 2,
    })
}

// 同花顺国际版授权
export const TicketCheck = params => {
    return get(`${baseUrl}/uc/${path_version}/TicketCheck`, {
        params,
        encrypt: ENCRYPT_TYPES.NO_ENCRYPT,
    })
}

// 重置交易密码开户证件号校验
export const IdNumberVerify = data => {
    const { value, code, salt, uin } = data
    const { A1 } = loginEncrypt(value, code, salt)

    return post(`${baseUrl}/uc/${path_version}/IdNumberVerify`, {
        data: {
            uin,
            ticket: A1,
        },
        encrypt: ENCRYPT_TYPES.NO_ENCRYPT,
        noEncTag: true,
    })
}

// 登录session展期
export const LoginSessionExtend = data => {
    return post(`${baseUrl}/uc/v1/SessionExtend`, { data })
}

// Esop登录session展期
export const EsopLoginSessionExtend = data => {
    return post(`${baseUrl}/uc/esop/v1/SessionExtend`, { data })
}

/** 更新注册未开户用户的邀请信息 */
export const UserInviteUpdate = data => {
    return post(`${baseUrl}/uc/v1/UserInviteUpdate`, { data })
}

/** 退出登录 https://www.tapd.cn/60236733/markdown_wikis/show/#1160236733001000142@toc18 */
export const Logout = data => {
    return post(`${baseUrl}/uc/v1/Logout`, { data })
}

export const FeatureCheck = data => {
    return post(`${baseUrl}/uc/v1/FeatureCheck`, { data })
}

/**
 * @name 客户顾问（APP）-列表
 */
export const getClientlist = params => {
    return get(`${baseUrl}/operation/v1/UserAdvisorList`, { params })
}

// 查询客户当前邀请关系
export const invitationRelationInfo = params => {
    return get(`${baseUrl}/uc/v1/InvitationRelation`, { params, encrypt: ENCRYPT_TYPES.LOGIN })
}

// 根据邀请码查看邀请人信息
export const inviterInfo = params => {
    return get(`${baseUrl}/uc/v1/InviterInfo`, { params, encrypt: ENCRYPT_TYPES.LOGIN })
}

// 根据邀请码查看邀请人信息
export const updateInvitationRelation = data => {
    return post(`${baseUrl}/uc/v1/InvitationRelationUpdate`, { data, encrypt: ENCRYPT_TYPES.LOGIN })
}

export const groupList = async (data, config) => {
    config = {
        params: data,
        encrypt: ENCRYPT_TYPES.LOGIN,
        jsonRpc: true,
        ...config,
    }
    return get(`${baseUrl}/uc/v1/GroupList`, config)
}
